import {Modal, Button, Alert, Form,} from "react-bootstrap";
import {useEffect, useState} from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPaperPlane, faBell, faSpinner } from '@fortawesome/free-solid-svg-icons'
import {useAuth} from "../../authprovider";
import {useLocation} from "react-router-dom";
import { useTranslation } from 'react-i18next';




function NotificationListItem(props){

    const data = props.data;

    return (
        <Alert className="mb-1 fw-light border p-2 text-black fw-normal " key={data.id} variant={data.variant}>
            <Form.Check className={"notification_form_check"}
                label={data.info}
                name="notification"
                value={data.id}
                type={"radio"}
                id={`notificationlist-${data.id}`}
            />
        </Alert>
    )

}

function CustomNotificationListItem(){

    const { t } = useTranslation();

    return (
        <div className="mb-1 font-monospace fw-light border p-2  ">
            <Form.Check className={"notification_form_check"}
                        name="notification"
                        label={t('notifications.customNotificationLabel')}
                        value={"custom_notification"}
                        type={"radio"}
                        id={`customnotification`}
            />
            <Form.Control name={"customNotification"} as="textarea" rows={3}  />
        </div>
    )

}

function Notification(props){

    const auth  = useAuth();
    const { t } = useTranslation();
    const [show, setShow] = useState(true);
    const data = props.data;



    const datetime = new Date(props.data.time_send);
    const timeString = datetime.toLocaleTimeString('pl-PL')
    const dateString = datetime.toLocaleDateString('pl-PL')

    const handleDeleteNotification = ()=>{
        let building_id = data.building_id

        const suffix =  'messages/'+building_id+"/"+data.id;

        auth.notifications.delete(suffix, response=>{
            const {success, error } = response;

            if(success === true){
                setShow(false)
            } else {
                alert(error)
            }
        })

    }

    return (
        <Alert show={show} key={data.id} className={"m-2 position-relative"} variant={data.variant} onClose={handleDeleteNotification} dismissible>
            <div className={"fs-smaller "}><b>{dateString} {timeString} </b></div>
            <div className={"fs-6 ps-3"}>{data.body} </div>
            <div className={"fs-smaller text-end"}>{t('notifications.evacuatedLabel')} <b>{data.evacuated} </b></div>
        </Alert>
    )


}

export default function NotificationManager(){

    const auth = useAuth();
    const location = useLocation();
     const building_id = location.hash ? location.hash.replace("#",'') : auth.user.building;
    const { t } = useTranslation();
    const [show,setShow] = useState(false)
    const [error, setError] = useState({show:false, info: ""})
    const [messages] = useState([
        {id:"notify_1", variant:"danger", info:"UWAGA W BUDYNKU WYKRYTO ZAGROŻENIE POŻAROWE, PROSIMY BEZPIECZNIE ZAKOŃCZYĆ WYKONYWANE CZYNNOŚCI I OPUŚCIĆ BUDYNEK DROGAMI EWAKUACYJNYMI. NIE KORZYSTAĆ Z WIND. UDAĆ SIĘ DO MIEJSCA ZBIÓRKI NA ZEWNĄTRZ BUDYNKU."},
        {id:"notify_2", variant:"danger",info: "UWAGA NA POLECENIE POLICJI PRZEPROWADZONA ZOSTANIE EWAKUACJA BUDYNKU ZE WZGLĘDU NA WYSTĘPUJĄCE NIEBEZPIECZEŃSTWO. PROSIMY BEZPIECZNIE ZAKOŃCZYĆ WYKONYWANE CZYNNOŚCI I OPUŚCIĆ BUDYNEK DROGAMI EWAKUACYJNYMI. NIE KORZYSTAĆ Z WIND. UDAĆ SIĘ DO MIEJSCA ZBIÓRKI NA ZEWNĄTRZ BUDYNKU."},
        {id:"notify_3", variant:"danger",info: "UWAGA W BUDYNKU WYSTĄPIŁO ZDARZENIE POŻAROWE NIE WYMAGAJĄCE EWAKUACJI. PROSIMY O ZACHOWANIE SPOKOJU I POZOSTANIE W MIEJSCACH PRACY"},
        {id:"notify_4", variant:"danger",info: "UWAGA W BUDYNKU WYSTĄPIŁA AWARJA SYSTEMÓW TECHNICZNYCH. PROSIMY O ZACHOWANIE SPOKOJU I POZOSTANIE W BUDYNKU."},
        {id:"notify_5", variant:"danger",info: "UWAGA W BUDYNKU WYSTĄPIŁA AWARJA SYSTEMÓW TECHNICZNYCH. DLA PAŃSTWA BEZPIECZEŃSTWA PROSIMY O ZABRANIE NIEZBĘDNYCH RZECZY I OPUSZCZENIE BUDYNKU DROGAMI EWAKUACYJNYMI. NIE KORZYSTAĆ Z WIND. UDAĆ SIĘ DO MIEJSCA ZBIÓRKI"},
        {id:"notify_6", variant:"warning",info: "W DNIU DZISIEJSZYM W BUDYNKU PROWADZONE BĘDĄ PRACE SERWISOWE SYSTEMÓW BEZPIECZEŃSTWA. PROSIMY O ZACHOWANIE OSTROŻNOŚCI"},
        {id:"notify_7",variant:"warning", info: "W DNIU DZISIEJSZYM W BUDYNKU PROWADZONE BĘDĄ PRACE WYSOKOŚCIOWE NA ELEWACJACH. PROSIMY O ZACHOWANIE SZCZEGÓLNEJ OSTROŻNOŚCI"},
        {id:"notify_8",variant:"warning", info: "UWAGA NA ZEWNĄTRZ BUDYNKU PANUJĄ NIEBEZPIECZNE WARUNKI ATMOSFERYCZNE. PROSIMY O ZACHOWANIE SZCZEGÓLNEJ OSTROŻNOŚCI PO WYJŚCIU"},
    ])
    const [notifications, setNotifications] = useState(undefined);
    const [sending, setSending] = useState(false)



    useEffect(()=>{
        let timer = setTimeout(downloadNotifications, 5000);

        if(notifications !== undefined)
            return function (){
                clearTimeout(timer);
            }

        downloadNotifications();

        return function (){
            clearTimeout(timer);
        }

    })

    function downloadNotifications(){

        const suffix =  'messages/'+building_id;

        auth.notifications.get(suffix, response=>{
            const {success, content} = response;

            if(success === true)
                setNotifications(content)
        })
    }


    function getMessageInfo(id){
        const message = messages.find((msg)=> msg.id === id);

        if(message === undefined)
            return "";

        return message.info;
    }


    function onHide(){
        setShow(false)
    }

    function insertNotification(notification){
        setNotifications([ notification, ...notifications])
    }

    function handleSubmit(event){
        event.preventDefault();
        event.stopPropagation();

        const form = event.currentTarget

        const checkedRadio = document.querySelector('input[name="notification"]:checked')

        if(checkedRadio === undefined)
            return;

        let customContent = form.customNotification ? form.customNotification.value : "";
        const message = messages.find((msg)=> msg.id === checkedRadio.value );

        const variant = message ? message.variant : "warning";

        if(checkedRadio.value === "custom" && customContent.length<=0)
            return;

        const suffix =  'message/'+building_id;

        const formData = {
            id: checkedRadio.value,
            variant:variant,
            content: customContent
        }

        setError({
            show:false,
            info:""
        });

        setSending(true)

        auth.notifications.add(formData,suffix, response=>{
            setSending(false);
            const {success, error, content} = response;

            if(success === true){
                insertNotification(content.message);
                setShow(false);
            } else {
                setError({
                    show:true,
                    info:error
                })
            }
        });

    }


    return (
        <div className={"notification_list"}>
            <Button name={"Wyślij"} className={"add_notification_btn"} variant={"warning"} onClick={()=>{setShow(true)}} >
                <FontAwesomeIcon icon={faBell} />  <b>{t('notifications.sendButton')}</b>
            </Button>

            {notifications && notifications.map(notification => {
                notification.info = getMessageInfo(notification.notification_id);

                return <Notification key={notification.id} data={notification} />
            })}

            <Modal
                show={show}
                onHide={onHide}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Form onSubmit={handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {t('notifications.sendModalTitle')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Alert variant="info">
                            {t('notifications.sendModalInfo')}
                        </Alert>
                        {messages &&
                            <>
                                <h5 className={"w-100 text-center"}>{t('notifications.threatsHeader')}</h5>
                                { messages.filter(msg=>msg.variant === "danger").map(msg=><NotificationListItem key={msg.id} data={msg} />)}
                                <h5 className={"w-100 text-center"}>{t('notifications.warningsHeader')}</h5>
                                { messages.filter(msg=>msg.variant === "warning").map(msg=><NotificationListItem key={msg.id} data={msg} />)}
                            </>
                        }
                        <h5 className={'w-100 text-center'}>{t('notifications.writeNotificationHeader')}</h5>
                        <CustomNotificationListItem />
                    </Modal.Body>
                    <Alert className={"m-2"} show={error.show} variant="danger">
                        {error.info}
                    </Alert>
                    <Modal.Footer className={"d-flex justify-content-between"}>

                        <Button name={"Anuluj"} variant={"secondary"} onClick={onHide}>{t('notifications.cancel')}</Button>
                        { sending ?
                            <Button name={"Czekaj"} type={"submit"} variant={"success"} ><FontAwesomeIcon icon={faSpinner}  spin/>{t('notifications.wait')}</Button>
                            :
                            <Button name={"Wyślij"} type={"submit"} variant={"success"} >{t('notifications.sendButtonShort')} <FontAwesomeIcon icon={faPaperPlane} /></Button>
                        }
                    </Modal.Footer>
                </Form>
            </Modal>

        </div>

    )
}